import { useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Global } from "../../../Variables/Global";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useLocation } from 'react-router-dom';

const Cart = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [AnItemNotInStock, setAnItemNotInStock] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const token = Cookies.get("CustomerToken");

  const [showModal, setShowModal] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalPriceThankYou, setTotalPriceThankYou] = useState(0);
  const handleModal = () => {
    setShowModal(!showModal);
    // Refresh the page when modal is closed
    navigate('/Cart');
    window.location.reload();
  };


  const getCartItems = async () => {
    setIsLoading(true);
    var groupId;
    if (Cookies.get("WishList") != undefined) {
      groupId = 4;
    } else {
      groupId = 3;
    }
    const offset = new Date().getTimezoneOffset();
    var CartId = Cookies.get("Cart");
    const token = Cookies.get("CustomerToken");
    fetch(
      Global.API_URL +
      "Cart/GetCartItems/" +
      CartId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((Result) => {
        setCartCount(Result.Count);
        setCartItems(Result.CartItems);
        setAnItemNotInStock(false)

        setIsLoading(false);
      });
  };

  const calculatTotalPrice = () => {
    let totalPrice = 0;
    cartItems.forEach((item) => {
      var price = item.IsPreOrder ? item.PreOrderPrice : (item.SalePrice != 0 ? item.SalePrice : item.RegularPrice);
      totalPrice += price * item.Quantity;
    });
    // Update total price state
    setTotalPrice(totalPrice);
    cartItems.map((item) => {
      if (!item.InStock) {
        setAnItemNotInStock(true)
      }
    });
  }

  useEffect(() => {
    calculatTotalPrice();
  }, [cartItems]);



  const HandleDelete = async (ProductVariationId) => {
    const CartId = Cookies.get("Cart");
    const token = Cookies.get("CustomerToken");
    let Response = await fetch(
      Global.API_URL +
      "Cart/RemoveItemFromCart" +
      "/" +
      ProductVariationId +
      "/" +
      CartId,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Global.API_URL,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          getCartItems();
          toast.success("Item Removed");

          return response.json();
        } else {
          return Response.text().then((text) => {
            throw new Error(text);
          });
        }
      })
      .catch((error) => {
        toast.error("Could Not Delete");
      });
  };

  const increaseQuantity = async (item) => {
    try {
      const CartId = Cookies.get("Cart");
      const token = Cookies.get("CustomerToken");
      const response = await fetch(`${Global.API_URL}Cart/AddItemToCart`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, },
        body: JSON.stringify({
          CartId: CartId, // get from state or context
          ProductId: item.ProductId,
          VariationId: item.ProductVariationId,
          PreOrderPrice: item.IsPreOrder > 0 ? item.PreOrderPrice : 0,
          Quantity: 1
        }),
      });

      if (response.ok) {
        // update quantity in local state
        setCartItems(prev =>
          prev.map(i =>
            i.ProductVariationId === item.ProductVariationId &&
              i.PreOrderPrice === item.PreOrderPrice // add this condition
              ? { ...i, Quantity: (i.Quantity ?? 1) + 1 }
              : i
          )
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const decreaseQuantity = async (item) => {
    try {
      const CartId = Cookies.get("Cart");
      const token = Cookies.get("CustomerToken");
      const response = await fetch(`${Global.API_URL}Cart/RemoveCartItem/${item.ProductVariationId}/${item.IsPreOrder}/${item.PreOrderPrice}/${CartId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        setCartItems(prev =>
          prev
            .map(i =>
              i.ProductVariationId === item.ProductVariationId &&
                i.PreOrderPrice === item.PreOrderPrice // match the pre-order price too
                ? { ...i, Quantity: (i.Quantity ?? 1) - 1 }
                : i
            )
            .filter(i => i.Quantity > 0) // remove if quantity <= 0
        );
        calculatTotalPrice();
      }
    } catch (err) {
      console.error(err);
    }
  };


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const resultIndicator = searchParams.get('resultIndicator');
    const orderId = searchParams.get('OrderId');

    if (orderId) {
      GetPopUpDetails(orderId);
    }

    if (resultIndicator) {


      fetch(
        Global.API_URL +
        "Order/CheckPayment?" +
        new URLSearchParams({
          ResultIndicator: resultIndicator,
        }),
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      ).then((response) => {

        if (response.ok) {
          toast.success("Payment Successfuly Compeleted");

          return response.json();

        }
        else {
          toast.error("Payment was not Compeleted");
        }
      }).then((response) => {

        navigate(`/Cart?OrderId=${response.OrderId}`);

      });
    }
  }, [location.search]);


  useEffect(() => {


    if (Cookies.get("CustomerToken") === undefined) {
      navigate("/UserAuthentication");
    } else {
      props.setHeaderTitle("Cart");
      props.setFooterActive(3);
      getCartItems();
    }
  }, []);

  function GetPopUpDetails(OrderId) {

    const id = Cookies.get("Number");
    fetch(
      Global.API_URL +
      "Order/GetThankYouPopUpDetails?" +
      new URLSearchParams({
        OrderId: OrderId,
        CustomerId: id
      }),
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }
    ).then((response) => {

      if (response.ok) {

        return response.json();

      }

    }).then((response) => {



      if (response != null) {

        let totalPrice = 0;
        response.Order.OrderDetails.map((item) => {
          totalPrice += item.TotalPrice;
        });
        setTotalPriceThankYou(totalPrice);
        setModalData(response);
        setShowModal(true);
      }
    });
  }

  function handleInputChange(ProductId, ProductVariationId, value) {
    const CartId = Cookies.get("Cart");
    const token = Cookies.get("CustomerToken");


    const updateData = [{
      ProductId: ProductId,
      VariationId: ProductVariationId,
      Quantity: value
    }];

    return fetch(Global.API_URL + "Cart/UpdateCartItemsQuantity/" + CartId, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": '*',
      },
      body: JSON.stringify(updateData),
    })
      .then((response) => response.json())
      .then((data) => {


        getCartItems();
      })
      .catch((error) => {
        console.error('Error updating cart items quantity:', error);
      });
  }



  return (
    <>
      {showModal && (
        <div className="container Cart">
          <div className="row d-none d-md-block">
            <div className="col-12 col-md-12">
              <ul className="bread-crumb">
                <li>Home</li>
                <li>/</li>
                <li>Thank You</li>
              </ul>
            </div>
          </div>

          {isLoading ? (
            <div className="spinner-container">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12 col-md-12" style={{ textAlign: 'center' }}>
                <br></br>
                <br></br>
                <h1>Thank You For You'r Order</h1>
              </div>
              <div>
                {totalPriceThankYou != 0 ?
                  <div className="row ">
                    <div className="col-12 col-lg-9">

                      <h1 style={{ marginBottom: "38px !important", color: 'black' }}>Order#  {modalData.Order.OrderId}</h1>
                      {
                        modalData && modalData.Order && modalData.Order.OrderDetails.map((item) => {
                          return (
                            <div
                              key={item.ProductVariationId}
                              className="infoBox position-relative shadowBoxMobile"
                            >
                              <div className="row ">
                                <div className="col-12 m-auto ">
                                  <div className="row">
                                    <div className="col-8">
                                      <label className="itemName">
                                        {item.ProductVariation.Sku}
                                        <span className="sale" style={{ marginLeft: '8px' }}>
                                          x{item.Quantity}
                                        </span>
                                      </label>

                                      <br />
                                      <span className="sale">
                                        ${item.PricePerItem}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row">
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="row">
                        <div className="col-12">
                          <div className="infoBox mt-0">
                            <div className="row">
                              <div class="col"> <p className="itemName" style={{ textAlignLast: "center", color: "black", height: "10px" }}>
                                Total :
                                <span>  ${totalPriceThankYou}</span>
                              </p></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : <div></div>
                }
              </div>
            </div>
          )}
        </div>
      )}

      {!showModal && (
        <div className="container Cart">
          <div className="row d-none d-md-block">
            <div className="col-12 col-md-12">
              <ul className="bread-crumb">
                <li>Home</li>
                <li>/</li>
                <li>Cart</li>
              </ul>
            </div>
          </div>

          {isLoading ? (
            <div className="spinner-container">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12 col-md-12">
                <h1>Cart({cartCount})</h1>
              </div>
              <div>
                <div className="row topMargin">
                  <div className="col-12 col-lg-9">
                    {cartItems.map((item) => {
                      // Determine the price to display
                      const displayPrice = item.IsPreOrder
                        ? item.PreOrderPrice
                        : item.SalePrice && item.SalePrice !== 0
                          ? item.SalePrice
                          : item.RegularPrice;

                      return (
                        <div
                          key={item.ProductVariationId}
                          className="infoBox position-relative shadowBoxMobile mb-3 p-3"
                          style={{
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)"
                          }}
                        >
                          <div className="row">
                            {/* Image + badges */}
                            <div className="col-12 col-md-3 position-relative">
                              <img
                                src={Global.PHOTO_URL + item.Image}
                                alt={item.ProductName}
                                className="cartImg w-100"
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  height: "80px"
                                }}
                              />
                              {!item.InStock && (
                                <div className="out-of-stock-overlay position-absolute top-0 start-0">
                                  Out of Stock
                                </div>
                              )}
                              {item.IsPreOrder && (
                                <div className="preorder-overlay position-absolute top-0 start-0">
                                  Pre-Order
                                </div>
                              )}
                            </div>

                            {/* Product Info */}
                            <div className="col-9 m-auto">
                              <div className="row">
                                <div className="col-8">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <label className="itemName fw-bold">{item.ProductName}</label>
                                    <button
                                      className="deleteBtn btn btn-link p-0"
                                      onClick={() => HandleDelete(item.ProductVariationId)}
                                    >
                                      <FaTrashAlt />
                                    </button>
                                  </div>

                                  {/* Attributes or Description */}
                                  {item.assignedAttributes && item.assignedAttributes.length > 0 ? (
                                    <p
                                      className="itemDesc mb-2"
                                      style={{ whiteSpace: "pre-line" }}
                                    >
                                      {item.assignedAttributes.map(a => `• ${a.AttributeName}: ${a.AttributeValueName}\n`).join('')}
                                    </p>
                                  ) : (
                                    <p
                                      className="itemDesc mb-2 text-truncate"
                                      style={{ maxHeight: "40px" }}
                                      dangerouslySetInnerHTML={{ __html: item.Description }}
                                    ></p>
                                  )}

                                  {/* Price */}
                                  {item.SalePrice && item.SalePrice !== 0 ? (
                                    <p>
                                      <span className="off">
                                        -{(((item.RegularPrice - item.SalePrice) * 100) / item.RegularPrice).toFixed(2)}%
                                      </span>{" "}
                                      <span className="old">
                                        Was: <strike>${item.RegularPrice}</strike>
                                      </span>{" "}
                                      <span className="sale">${displayPrice}</span>
                                    </p>
                                  ) : (
                                    <p>
                                      <span className="sale">${displayPrice}</span>
                                    </p>
                                  )}
                                </div>

                                {/* Quantity controls and total */}
                                <div className="col-lg-3 col-sm-12 d-flex flex-column align-items-center mt-2">
                                  <div className="d-flex align-items-center mb-1">
                                    {/* Decrease Quantity */}
                                    <button
                                      className="btn btn-sm d-flex align-items-center justify-content-center"
                                      style={{ width: "30px", height: "30px", borderRadius: "50%", padding: 0, backgroundColor: "#d01214", border: "none", color: "white" }}
                                      onClick={async () => {
                                        if (item.InStock) {
                                          await decreaseQuantity(item);
                                        }
                                      }}
                                    >
                                      -
                                    </button>

                                    {/* Quantity Box */}
                                    <div
                                      className="quantityBox mx-1 text-center d-flex align-items-center justify-content-center"
                                      style={{ width: "50px", height: "30px", border: "1px solid #ccc", borderRadius: "4px" }}
                                    >
                                      {item.Quantity}
                                    </div>

                                    {/* Increase Quantity */}
                                    <button
                                      className="btn btn-sm d-flex align-items-center justify-content-center"
                                      style={{ width: "30px", height: "30px", borderRadius: "50%", padding: 0, backgroundColor: "#d01214", border: "none", color: "white" }}
                                      onClick={async () => {
                                        if (item.InStock) {
                                          await increaseQuantity(item);
                                        }
                                      }}
                                    >
                                      +
                                    </button>
                                  </div>

                                  {/* Total Price */}
                                  <span className="sale fw-bold">
                                    ${(displayPrice * item.Quantity).toFixed(2)}
                                  </span>
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>



                  <div className="col-12 col-lg-3">
                    {totalPrice != 0 ? <div className="row">
                      <div className="col-12">
                        <div className="infoBox mt-0">
                          <div className="row">
                            <div class="col"> <p className="itemName" style={{ textAlignLast: "center", color: "black", height: "10px" }}>
                              Total :
                              <span>  ${totalPrice}</span>
                            </p></div>
                          </div>
                        </div>
                      </div>
                    </div> : null}
                    <div className="row">
                      <div className="col-12">
                        <Link
                          to={(cartCount > 0) && AnItemNotInStock ? "" : "/Checkout"}
                          state={{ cartItems: cartItems, cartCount: cartCount }}
                          onClick={() => AnItemNotInStock ? toast.error("Remove Out Of Stock Item From Cart") : ""}
                        >
                          <button

                            type="button"
                            className={AnItemNotInStock ? "proceedBtn cartBtn disabled" : "proceedBtn cartBtn"}
                          >
                            proceed to checkout
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <Link to="/" type="button" className="continueBtn">
                          continue Shopping
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default Cart;
